import { render, staticRenderFns } from "./UnconsideredPlatesListComponent.vue?vue&type=template&id=71677795&scoped=true"
import script from "./UnconsideredPlatesListComponent.vue?vue&type=script&lang=js"
export * from "./UnconsideredPlatesListComponent.vue?vue&type=script&lang=js"
import style0 from "./UnconsideredPlatesListComponent.vue?vue&type=style&index=0&id=71677795&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71677795",
  null
  
)

export default component.exports